import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import { colors } from "../../../constants/colors";
import checkIcon from "../../../resources/images/check-blue-icon.svg";

const styles = createUseStyles(theme => ({
  backdropModal: {
    "& .modal-content": {
      position: "relative",
      "&::after": {
        content: '""',
        position: "absolute",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        borderRadius: "inherit",
        zIndex: 1,
      }
    }
  },
  titleContainer: {
    display: "flex",
    fontWeight: "600",
    alignItems: "center",
  },
  tripCreditsSettingsModal: {
    width: "500px",
    "& .modal-header": {
      padding: "24px 24px 20px",
      "& div": {
        height: "46px",
        padding: "10px",
        "& svg": {
          display: "flex"
        }
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px"
      }
    },
    "& .modal-title": {
      padding: "0 24px"
    },
    "& .modal-body": {
      padding: "8px 24px",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px"
    },
    "& .modal-footer": {
      padding: "24px 24px"
    },
    "& .modal-footer>*": {
      margin: "0px"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  modalContent: {
    margin: "20px 0 0 0",
    display: "grid",
    gap: "12px"
  },
  optionContainer:{
    cursor: "pointer",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    border: "1px solid " + colors.lightGrey,
    borderRadius: "12px",
    padding: "16px",
    gap: "16px",
    "&:hover": {
      border: theme.modal.optionHover.border,
      "& input":{
        backgroundColor: theme.modal.optionHover.backgroundColor,
        border: theme.buttons.primary.border,
      },
    },
    "& input":{
      appearance: "none",
      width: "16px",
      height: "16px",
      border: "1px solid " + colors.lightGrey,
      borderRadius: "8px",
      cursor: "pointer",
      flexShrink: 0,
      "&:checked": {
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundImage: `url(${checkIcon})`
      }
    },
  },
  selectedOptionContainer:{
    justifyContent: "space-between",
    border: theme.modal.selectedOption.border,
    backgroundColor: theme.modal.selectedOption.backgroundColor,
    color: theme.modal.selectedOption.text.color,
    padding: "15px",
    "&:hover": {
      border: theme.modal.selectedOption.border,
    },
    "& input":{
      border: "none",
    },
  },
  lockedOptionSelectedContainer: {
    border: "2px solid " + colors.lightGrey,
    backgroundColor: colors.brightBlue,
    "& input": {
      backgroundColor: colors.darkGrey + " !important",
      cursor: "not-allowed",
      "&:checked": {
        filter: "grayscale(100%) opacity(0.3) !important",
      }
    },
    "& h3":{
      color: colors.grey,
    },
    "& p":{
      color: colors.mediumGrey,
    },
    "&:hover": {
      border: "2px solid " + colors.lightGrey,
    },
  },
  textContainer: {
    alignContent: "center"
  },
  lockedOptionContainer: {
    "&:hover": {
      border: "1px solid " + colors.lightGrey,
      "& input":{
        border: "1px solid " + colors.lightGrey,
        backgroundColor: "initial"
      },
    },
  },
  confirmBtn: {
    width:"100%",
    justifyContent:"center",
    fontSize: "16px",
    fontWeight:"600",
    lineHeight:"20px",
    fontFamily: theme.fontFamily,
  },
  btnContainer:{
    marginTop:"32px",
    width: "100%"
  },
  cancelBtn: {
    width:"100%",
    justifyContent:"center",
    fontSize: "16px",
    fontWeight:"600",
    lineHeight:"20px",
    fontFamily: theme.fontFamily,
    height: "100%",
    alignItems: "center"
  },
  colCancel:{
    padding:"0px",
    marginRight:"12px"
  },
  colRemove:{
    padding:"0px"
  },
  btnsRow: {
    flexWrap: "nowrap"
  },
  descriptionDiv: {
    display: "flex",
  },
  updatesNotificationBanner: {
    display: "grid",
    backgroundColor: colors.advertOrange,
    padding: "8px",
    borderRadius: "12px"
  },
  warningTitle: {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "20px",
    color: colors.warning700,
    margin: "0px",
    marginBottom: "6px"
  },
  warningDescription: {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    color: colors.warning600,
    margin: "0px"
  },
  lockSvg: {
    width: "42px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "8px",
    "& svg": {
      width: "24px",
      height: "24px",
      "& path": {
        stroke: colors.warning600
      }
    }
  },
  warningSvg: {
    width: "42px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "8px",
    "& svg": {
      width: "24px",
      height: "24px"
    }
  },
  accordion: {
    "--bs-accordion-border-width": "0px",
    "--bs-accordion-bg": "inherit",
    "& .accordion-button": {
      backgroundColor: "inherit",
      padding: "0px",
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
      color: colors.grey,
      display: "flex",
      alignItems: "center",
      gap: "8px",
      "&::after": {
        marginLeft: "0",
        marginRight: "auto",
        flexShrink: 0,
        order: 1,
        width: "0.75rem",
        height: "0.75rem",
        backgroundSize: "0.75rem",
      },
      "& > *:last-child": {
        order: 2,
        marginLeft: "auto",
      },
      "&:focus": {
        outline: "none",
        boxShadow: "none",
      },
    },
  },
  accordionItem: {
    width: "100%",
    "& .accordion-body": {
      padding: "8px 0 0 0",
      "& p": {
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "20px",
        color: colors.mediumGrey,
        margin: 0,
        textAlign: "justify"
      }
    }
  },
  selectedAccordionItem: {
    "& .accordion-button": {
      color: colors.primary600Blue,
    },
    "& .accordion-body p": {
      color: colors.primary600Blue,
      textAlign: "justify"
    }
  },
  divider: {
    color: colors.lightGrey,
    opacity: "1",
    margin: "8px 0px",
  },
}));

export default styles;
